<div class="loadingBox" *ngIf="!loaded">
  <img class="pulsate" src="assets/img/hostbrand/core-whitelogo.svg" width="300">
  <h3 *ngIf="!failed" i18n="@@Confirming Sub check phone | Confirming Sub check phone" class="subLoading pulsate" >Confirming Subscription. Check your phone for details</h3>
  <h3 *ngIf="failed" i18n="@@Unable to confirm sub | Unable to confirm sub message" class="subLoadingSmall">Unable to confirm your subscription. Please try again later or contact support@videyo.tv for help.</h3>
</div>
<div *ngIf="loaded">
  <div class="container-fluid mt-2">
      <div class="row">
          <div class="col-md-12">
            <h1 style="text-align: center;">Subscribe to {{siteInfo.name}}</h1>
              <div class="row">
                  <div class="col-md-8 offset-md-2 subBoxWrap">
                    <div (click)="goToSubPage(currencySign, product.billingAgent.name, product.id, product.cost, product.billingFrequency.name)" class="item d-flex align-items-stretch subBox" *ngFor="let product of products let i=index;">
                             <div class="channels-card">
                                 <div class="channels-card-image video-box">      
                                  <img src="{{product.imageUrl}}"/>
                                  <h3 class="payOption">Pay via {{product.billingAgent.name}} ({{product.billingFrequency.name}})</h3>
                                  <p>
                                      <span>You will be charged:</span> {{currencySign}}{{product.cost}} {{product.billingFrequency.name}}</p>
                                      <a href="javascript:;" (click)="goToSubPage(currencySign, product.billingAgent.name, product.id, product.cost, product.billingFrequency.name)" class="unsubbutton white-outline-button subButton">Subscribe Now</a> 
                                    <br/>
                                    
                                    
                                    </div>
                                 <div class="channels-card-body">
                                 </div>
                              </div>
                          </div>
                   </div>
                   <a style="width: 50%; margin-left: 25%; display: inline-block; text-align: center; margin-top: 50px;" routerLink="/" class="unsubbutton white-outline-button subButton">Back to Home</a> 
                   
              </div>
          </div>
      </div>
  </div>